import Basic from "./Basic"
import IOSwitch from "./IOSwitch"

export default {
    Basic,
    IOSwitch,
  
  
};